import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/PageHeader';
import { About } from '../components/About';
import { LeafIcon, AnchorIcon, HeartIcon } from 'lucide-react';
export function AboutPage() {
  const {
    t
  } = useLanguage();
  return <motion.div initial={{
    opacity: 0,
    filter: 'blur(4px)'
  }} animate={{
    opacity: 1,
    filter: 'blur(0px)'
  }} exit={{
    opacity: 0,
    filter: 'blur(4px)'
  }} transition={{
    duration: 0.6,
    ease: [0.4, 0, 0.2, 1]
  }} data-id="element-301">
      <PageHeader title={t.about.title} subtitle={t.about.subtitle} backgroundImage="https://cdn.magicpatterns.com/uploads/mxDCDACSNQm7FUGMSjGx27/WhatsApp_Image_2026-04-27_at_16.57.18.jpg" data-id="element-302" />

      <About data-id="element-303" />

      {/* Restaurant Gallery Strip */}
      <section className="py-20 lg:py-28 bg-cream bg-sand-texture relative" data-id="element-304">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10" data-id="element-305">
          <div className="text-center mb-14" data-id="element-306">
            <div className="flex items-center justify-center gap-5 mb-6" data-id="element-307">
              <div className="h-px w-12 bg-gradient-to-r from-transparent to-sand/50" data-id="element-308"></div>
              <span className="text-sand text-[11px] font-medium tracking-[0.35em] uppercase" data-id="element-309">
                Nuestro Espacio
              </span>
              <div className="h-px w-12 bg-gradient-to-l from-transparent to-sand/50" data-id="element-310"></div>
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6" data-id="element-311">
            {[{
            src: 'https://cdn.magicpatterns.com/uploads/mxDCDACSNQm7FUGMSjGx27/WhatsApp_Image_2026-04-27_at_16.57.18.jpg',
            alt: 'Fachada El Astillero'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/cnubUTM1mqn1ZxvmEM841T/WhatsApp_Image_2026-04-27_at_16.31.29.jpg',
            alt: 'Plato de pescado con vinos El Astillero'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/bqmFNx8L7g7urQSioN5d6M/WhatsApp_Image_2026-04-27_at_16.57.59.jpg',
            alt: 'Piscina con sombrillas'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/f4UjvbVTFvC5TP7C4md87c/WhatsApp_Image_2026-04-27_at_17.03.32.jpg',
            alt: 'Barco decorativo'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/czyTYDeTmADrQUYXqE1CTw/WhatsApp_Image_2026-04-27_at_16.31.30.jpg',
            alt: 'Tataki de atún'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/pMgaJM1usm7E8sUALYHgtT/WhatsApp_Image_2026-04-27_at_16.58.06.jpg',
            alt: 'Terraza y piscina'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/rHjP7fGanNXL6Fibv5UAnJ/WhatsApp_Image_2026-04-27_at_16.58.18.jpg',
            alt: 'Jardín mediterráneo'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/dabSJ1gBHWuLsD4Bem7Le7/WhatsApp_Image_2026-04-27_at_17.04.18.jpg',
            alt: 'Vista general del restaurante'
          }].map((img, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.08,
            duration: 0.8,
            ease: [0.4, 0, 0.2, 1]
          }} className={`relative overflow-hidden rounded-xs shadow-soft group ${idx === 0 ? 'col-span-2 row-span-2' : ''} ${idx === 4 ? 'col-span-2' : ''}`} data-id="element-312">
                <div className={`w-full ${idx === 0 ? 'h-[280px] sm:h-[400px]' : 'h-[180px] sm:h-[200px]'}`} data-id="element-313">
                  <img src={img.src} alt={img.alt} className="w-full h-full object-cover transition-transform duration-[1.2s] ease-elegant group-hover:scale-105" data-id="element-314" />
                </div>
                <div className="absolute inset-0 bg-navy/0 group-hover:bg-navy/15 transition-all duration-700" data-id="element-315" />
              </motion.div>)}
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 section-divider" data-id="element-316" />
      </section>

      {/* Pet Friendly Section */}
      <section className="py-28 lg:py-36 bg-warmWhite relative overflow-hidden" data-id="element-317">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10" data-id="element-318">
          <div className="flex flex-col lg:flex-row-reverse items-center gap-14 lg:gap-24" data-id="element-319">
            {/* Image Side — Chato */}
            <motion.div initial={{
            opacity: 0,
            x: 35
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 1.2,
            ease: [0.4, 0, 0.2, 1]
          }} className="w-full lg:w-5/12 relative" data-id="element-320">
              <div className="relative aspect-[4/3] w-full rounded-xs overflow-hidden shadow-elegant" data-id="element-321">
                <img src="https://cdn.magicpatterns.com/uploads/7EsAibVEQPhGfeBzByj85p/WhatsApp_Image_2026-05-03_at_13.06.11_(4).jpg" alt="Chato, la mascota de El Astillero, junto al logo del restaurante" className="absolute inset-0 w-full h-full object-cover" data-id="element-322" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/10 to-transparent" data-id="element-323" />
              </div>
              <div className="absolute -bottom-5 -left-5 w-full h-full border border-sand/15 rounded-xs -z-10" data-id="element-324"></div>
              {/* Small secondary image */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3,
              duration: 0.8
            }} className="absolute -bottom-8 -right-4 lg:-right-8 w-32 h-32 lg:w-40 lg:h-40 rounded-xs overflow-hidden shadow-deep border-4 border-warmWhite z-10" data-id="element-325">
                <img src="https://cdn.magicpatterns.com/uploads/rTSUPy5fS11Lp5PWv6KpPf/WhatsApp_Image_2026-05-03_at_13.06.11.jpg" alt="Chato frente al Club Náutico" className="w-full h-full object-cover" data-id="element-326" />
              </motion.div>
            </motion.div>

            {/* Text Side */}
            <motion.div initial={{
            opacity: 0,
            x: -35
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 1.2,
            delay: 0.15,
            ease: [0.4, 0, 0.2, 1]
          }} className="w-full lg:w-7/12 flex flex-col justify-center" data-id="element-327">
              <div className="flex items-center gap-5 mb-8" data-id="element-328">
                <div className="h-px w-16 bg-gradient-to-r from-sand to-sand/30" data-id="element-329"></div>
                <span className="text-sand text-[11px] font-medium tracking-[0.35em] uppercase" data-id="element-330">
                  🐾 Pet Friendly
                </span>
              </div>

              <h2 className="font-serif text-4xl md:text-5xl text-navy mb-8 leading-[1.1]" data-id="element-331">
                Tu mascota también es bienvenida
              </h2>

              <div className="space-y-6 text-dark/55 font-light leading-[2] text-[15px]" data-id="element-332">
                <p data-id="element-333">
                  En El Astillero creemos que las mejores experiencias se
                  comparten con toda la familia, incluidos los de cuatro patas.
                  Por eso, somos un restaurante{' '}
                  <strong className="font-medium text-navy/80" data-id="element-334">
                    100% Pet Friendly
                  </strong>
                  .
                </p>
                <p data-id="element-335">
                  Tu compañero peludo es bienvenido tanto en nuestra{' '}
                  <strong className="font-medium text-navy/80" data-id="element-336">
                    terraza exterior
                  </strong>{' '}
                  como en los{' '}
                  <strong className="font-medium text-navy/80" data-id="element-337">
                    jardines y zonas comunes
                  </strong>{' '}
                  del recinto. Disponemos de agua fresca y espacio para que
                  disfruten mientras tú saboreas nuestra cocina mediterránea.
                </p>
                <p className="text-dark/40 text-sm italic" data-id="element-338">
                  En la foto, Chato — el bulldog inglés de Diego — descansando
                  junto al logo del restaurante. Uno más de la familia de El
                  Astillero.
                </p>
              </div>

              <div className="mt-10 flex flex-wrap gap-4" data-id="element-339">
                <div className="flex items-center gap-2.5 px-4 py-2.5 bg-sand/8 rounded-full border border-sand/15" data-id="element-340">
                  <span className="text-lg" data-id="element-341">🌿</span>
                  <span className="text-navy/70 text-xs font-medium tracking-wide uppercase" data-id="element-342">
                    Terraza exterior
                  </span>
                </div>
                <div className="flex items-center gap-2.5 px-4 py-2.5 bg-sand/8 rounded-full border border-sand/15" data-id="element-343">
                  <span className="text-lg" data-id="element-344">🌳</span>
                  <span className="text-navy/70 text-xs font-medium tracking-wide uppercase" data-id="element-345">
                    Jardines amplios
                  </span>
                </div>
                <div className="flex items-center gap-2.5 px-4 py-2.5 bg-sand/8 rounded-full border border-sand/15" data-id="element-346">
                  <span className="text-lg" data-id="element-347">💧</span>
                  <span className="text-navy/70 text-xs font-medium tracking-wide uppercase" data-id="element-348">
                    Agua fresca disponible
                  </span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 section-divider" data-id="element-349" />
      </section>

      {/* Philosophy Section */}
      <section className="py-32 lg:py-44 text-white relative overflow-hidden" data-id="element-350">
        {/* Video Background — Mediterranean coast */}
        <div className="absolute inset-0 w-full h-full z-0" data-id="element-351">
          <video autoPlay loop muted playsInline className="object-cover w-full h-full opacity-50 scale-105" data-id="element-352">
            <source src="https://videos.pexels.com/video-files/1093662/1093662-uhd_2560_1440_30fps.mp4" type="video/mp4" data-id="element-353" />
          </video>
          <div className="absolute inset-0 bg-navy/85 backdrop-blur-[3px]" data-id="element-354" />
        </div>
        {/* Warm ambient glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-sunset-gold/[0.05] rounded-full blur-[120px] pointer-events-none z-[1]" data-id="element-355" />

        <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-10 relative z-10" data-id="element-356">
          <div className="text-center mb-18" data-id="element-357">
            <motion.div initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="flex items-center justify-center gap-5 mb-6" data-id="element-358">
              <div className="h-px w-12 bg-gradient-to-r from-transparent to-sand/40" data-id="element-359"></div>
              <span className="text-sand-light text-[11px] font-medium tracking-[0.35em] uppercase" data-id="element-360">
                {t.about.philosophySubtitle}
              </span>
              <div className="h-px w-12 bg-gradient-to-l from-transparent to-sand/40" data-id="element-361"></div>
            </motion.div>
            <motion.h2 initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1,
            duration: 0.8
          }} className="font-serif text-4xl md:text-5xl lg:text-[3.5rem]" data-id="element-362">
              {t.about.philosophyTitle}
            </motion.h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16" data-id="element-363">
            {[{
            icon: LeafIcon,
            title: t.about.phil1Title,
            desc: t.about.phil1Desc
          }, {
            icon: AnchorIcon,
            title: t.about.phil2Title,
            desc: t.about.phil2Desc
          }, {
            icon: HeartIcon,
            title: t.about.phil3Title,
            desc: t.about.phil3Desc
          }].map((item, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 25
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.15,
            duration: 0.8
          }} className="text-center" data-id="element-364">
                <div className="w-14 h-14 mx-auto bg-sand/10 rounded-full flex items-center justify-center mb-8 ring-1 ring-sand/10" data-id="element-365">
                  <item.icon className="w-6 h-6 text-sand" data-id="element-366" />
                </div>
                <h3 className="font-serif text-xl mb-5" data-id="element-367">{item.title}</h3>
                <p className="text-white/45 font-light leading-[1.85] text-sm" data-id="element-368">
                  {item.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-32 lg:py-44 bg-cream bg-sand-texture relative" data-id="element-369">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10" data-id="element-370">
          <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-28" data-id="element-371">
            <motion.div initial={{
            opacity: 0,
            x: -35
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 1,
            ease: [0.4, 0, 0.2, 1]
          }} className="w-full lg:w-5/12 relative" data-id="element-372">
              {/* Single Editorial Image Composition */}
              <div className="relative w-full aspect-[4/5] rounded-xs overflow-hidden shadow-deep" data-id="element-373">
                <img src="https://cdn.magicpatterns.com/uploads/ugRx7pMZ5rmDGuHHdh6og6/Captura_de_pantalla_2026-04-17_a_las_15.57.58.png" alt="Chef El Astillero" className="w-full h-full object-cover object-center" data-id="element-374" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/20 to-transparent mix-blend-overlay" data-id="element-375"></div>
              </div>
              {/* Decorative accent frame */}
              <div className="absolute -bottom-6 -left-6 w-full h-full border border-sand/20 rounded-xs -z-10" data-id="element-376"></div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 40
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            delay: 0.15,
            ease: [0.4, 0, 0.2, 1]
          }} className="w-full lg:w-7/12" data-id="element-377">
              <div className="flex items-center gap-5 mb-8" data-id="element-378">
                <div className="h-px w-16 bg-gradient-to-r from-sand to-sand/30" data-id="element-379"></div>
                <span className="text-sand text-[11px] font-medium tracking-[0.35em] uppercase" data-id="element-380">
                  {t.about.teamSubtitle}
                </span>
              </div>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-navy mb-12 leading-[1.1]" data-id="element-381">
                {t.about.teamTitle}
              </h2>
              <p className="text-dark/55 font-light leading-[2] text-[15px] mb-14" data-id="element-382">
                {t.about.teamDesc}
              </p>
              <Link to="/reservations" className="inline-block px-12 py-4.5 bg-sand text-navy hover:bg-sand-dark transition-all duration-700 ease-elegant font-medium text-[11px] tracking-[0.2em] uppercase hover:shadow-warm hover:scale-[1.02]" data-id="element-383">
                {t.nav.bookNow}
              </Link>
            </motion.div>
          </div>
        </div>
      </section>
    </motion.div>;
}